<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>站点设置</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row>
        <el-col :span="24">
          <el-form ref="formSiteRef" :model="formSite" label-width="80px">
            <el-form-item label="LOGO">
              <el-upload
                :action="urlApi"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过1MB
                </div>
              </el-upload>
              <div class="viewimg">
                <img :src="formSite.imageUrl" alt="" />
              </div>
            </el-form-item>
            <el-form-item label="系统名称" width="300px">
              <el-input
                v-model="formSite.SystemName"
                placeholder="请输入系统名称"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import bus from '../../../bus'
export default {
  data() {
    return {
      urlApi:
        process.env.VUE_APP_BASE_URL +
        '/api/SiteSettings/AddUploadPicturesInfo',
      formSite: {
        imageUrl: '',
        SystemName: ''
      }
    }
  },
  created() {
    this.getLogoInfo()
  },
  methods: {
    // 回填logo和系统名称
    async getLogoInfo() {
      const { data: res } = await this.$http.get(
        '/api/SiteSettings/GetSiteSettings'
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.formSite = {
        imageUrl: process.env.VUE_APP_BASE_URL + res.Data.FileName,
        SystemName: res.Data.SystemName
      }
      // 向Home.vue页面发送logo和系统名称数据
      bus.$emit('uplogosrc', this.formSite)
    },
    // 保存系统名称
    async onSubmit() {
      const { data: res } = await this.$http.post(
        '/api/SiteSettings/ModSystemName',
        this.formSite
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.$message.success(res.Msg)

      this.getLogoInfo()
    },
    handleAvatarSuccess(res, file) {
      this.getLogoInfo()
      console.log(this.formSite)
    },
    beforeAvatarUpload(file) {
      console.log(file)
      const isLt2M = file.size / 1024 / 1024 < 1
      if (['image/jpeg', 'image/png'].indexOf(file.type) === -1) {
        this.$message.error('上传图片只能是 JPG、PNG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 1MB!')
        return false
      }
      return true
    }
  }
}
</script>
<style lang="less" scoped>
.viewimg {
  display: flex;
  align-items: center;
  img {
    width: 100px;
    margin-right: 10px;
  }
}
.el-upload__tip {
  margin-bottom: 0;
}
</style>
